import * as React from "react";
import { WorkspaceProvider } from "@radarly/core/workspace/context";
import { useCurrentWorkspaceBootstrap } from "./use-cases";

export default function WorkspaceConnectedPage({
  id,
  children,
  onAccessError,
  onLoading,
}: {
  id: number;
  children: React.ReactNode;
  onAccessError: () => React.ReactNode;
  onLoading: () => React.ReactNode;
}) {
  const { loading, workspace, error } = useCurrentWorkspaceBootstrap(id);
  return (
    <WorkspaceProvider workspace={workspace}>
      <React.Suspense fallback={onLoading()}>
        {!loading ? (!!error ? onAccessError() : children) : onLoading()}
      </React.Suspense>
    </WorkspaceProvider>
  );
}
